import { render, staticRenderFns } from "./LoginPersonalizePage.vue?vue&type=template&id=4f05e482&scoped=true"
import script from "./LoginPersonalizePage.vue?vue&type=script&lang=js"
export * from "./LoginPersonalizePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f05e482",
  null
  
)

export default component.exports